import { render, staticRenderFns } from "./delivery-slack.vue?vue&type=template&id=090522e8"
import script from "./delivery-slack.vue?vue&type=script&lang=js"
export * from "./delivery-slack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports